/* herQs 2026-11-02 (vragen 609, 617, 627, teller en 633): leverregel PDP, balk en mandbalk gratis verzending. Alleen NL-markup gebruikt dit. */
(() => {
  const DAGEN = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  const NAMEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  const geld = (cent) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cent / 100).replace(/\s/g, '');
  const lijst = (s) => (s || '').toLowerCase().split(',').map((d) => DAGEN.indexOf(d.trim())).filter((i) => i >= 0);

  // Huidige tijd in Europe/Amsterdam als {dag (0=zo), minuten sinds middernacht, datumsleutel}
  function nuAmsterdam() {
    const p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit' })
      .formatToParts(new Date()).reduce((a, x) => (a[x.type] = x.value, a), {});
    const dag = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
    const sec = parseInt(p.hour, 10) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10);
    return { dag, min: Math.floor(sec / 60), sec };
  }

  // Bezorgdag: verzonden op de eerstvolgende verzenddag (vandaag als vóór cut-off), bezorgd de dag erna of de eerstvolgende bezorgdag.
  function bezorging(cutoff, verzend, bezorg) {
    const [h, m] = cutoff.split(':').map((x) => parseInt(x, 10));
    const cut = (h || 0) * 60 + (m || 0);
    const nu = nuAmsterdam();
    let offset = 0;
    if (!(verzend.includes(nu.dag) && nu.min < cut)) {
      offset = 1;
      while (!verzend.includes((nu.dag + offset) % 7) && offset < 8) offset++;
    }
    let lever = offset + 1;
    while (!bezorg.includes((nu.dag + lever) % 7) && lever < 15) lever++;
    return { vandaagVerzonden: offset === 0, resterend: cut - nu.min, resterendSec: cut * 60 - nu.sec, leverOffset: lever, leverDag: (nu.dag + lever) % 7 };
  }

  // Teller uu:mm:ss (vraag na 627: "ik mis de teller")
  function teller(sec) {
    const s = Math.max(0, sec), u = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), r = s % 60;
    return [u, m, r].map((x) => String(x).padStart(2, '0')).join(':');
  }

  class HerqsLevering extends HTMLElement {
    connectedCallback() {
      this.render();
      this.timer = setInterval(() => this.render(), 1000);
      this.onVariant = (e) => {
        if (e.detail && e.detail.formId === this.dataset.formId && e.detail.variant) {
          const v = e.detail.variant;
          this.dataset.prijs = v.price;
          this.dataset.voorraad = v.available && (!v.inventory_management || v.inventory_quantity > 0) ? 'true' : 'false';
          this.render();
        }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    disconnectedCallback() { clearInterval(this.timer); document.removeEventListener('variant:change', this.onVariant); }
    render() {
      const drempel = parseInt(this.dataset.drempel, 10), prijs = parseInt(this.dataset.prijs, 10);
      const gratis = this.querySelector('.herqs-levering__rij--gratis .herqs-levering__kop');
      gratis.textContent = prijs >= drempel ? 'Gratis verzending' : `Gratis verzending vanaf ${geld(drempel).replace(',00', '')}`;
      const rij = this.querySelector('.herqs-levering__rij--lever');
      if (!(this.dataset.morgen === 'true' && this.dataset.voorraad === 'true')) { rij.hidden = true; return; }
      const b = bezorging(this.dataset.cutoff, lijst(this.dataset.verzenddagen), lijst(this.dataset.bezorgdagen || 'di,wo,do,vr,za'));
      const kop = rij.querySelector('.herqs-levering__kop'), sub = rij.querySelector('.herqs-levering__sub');
      // vraag 633 (Bram letterlijk): "bestel binnen xxx en geniet morgen van maximale warmte en minimale rook."
      const dag = b.leverOffset === 1 ? 'morgen' : NAMEN[b.leverDag];
      const zin = `en geniet ${dag} van maximale warmte en minimale rook.`;
      if (sub.textContent !== zin) sub.textContent = zin;
      if (b.vandaagVerzonden && b.leverOffset === 1) {
        let el = kop.querySelector('.herqs-levering__aftel');
        if (!el) { kop.innerHTML = 'Bestel binnen <span class="herqs-levering__aftel" role="timer"></span>'; el = kop.querySelector('.herqs-levering__aftel'); }
        el.textContent = teller(b.resterendSec);
      } else if (kop.textContent !== 'Bestel nu') {
        kop.textContent = 'Bestel nu';
      }
      rij.hidden = false;
    }
  }
  if (!customElements.get('herqs-levering')) customElements.define('herqs-levering', HerqsLevering);

  // Aankondigingsbalk: zelfde bezorgregels als de PDP (vraag 617). Copy vraag 633; de bloktekst is alleen de tekst zonder JS.
  class HerqsLeverBalk extends HTMLElement {
    connectedCallback() {
      if (this.basis === undefined) this.basis = this.textContent.trim();
      this.render();
      this.timer = setInterval(() => this.render(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    render() {
      const b = bezorging(this.dataset.cutoff || '22:00', lijst(this.dataset.verzenddagen || 'ma,di,wo,do,vr'), lijst(this.dataset.bezorgdagen || 'di,wo,do,vr,za'));
      // vraag 633 (Bram letterlijk): "Bestel binnen uu:mm:ss en geniet morgen van maximale warmte en minimale rook"
      if (b.vandaagVerzonden && b.leverOffset === 1) {
        let el = this.querySelector('.herqs-ab__teller');
        if (!el) { this.innerHTML = 'Bestel binnen <span class="herqs-ab__teller" role="timer"></span> en geniet morgen van maximale warmte en minimale rook'; el = this.querySelector('.herqs-ab__teller'); }
        el.textContent = teller(b.resterendSec);
      } else {
        const tekst = `Bestel nu en geniet ${b.leverOffset === 1 ? 'morgen' : NAMEN[b.leverDag]} van maximale warmte en minimale rook`;
        if (this.textContent !== tekst) this.textContent = tekst;
      }
    }
  }
  if (!customElements.get('herqs-lever-balk')) customElements.define('herqs-lever-balk', HerqsLeverBalk);

  class HerqsGratisBalk extends HTMLElement {
    connectedCallback() {
      this.render();
      this.onCart = (e) => {
        const c = e.detail && e.detail.cart; if (!c) return;
        const items = c.items.filter((i) => i.requires_shipping).reduce((s, i) => s + i.final_line_price, 0);
        const korting = (c.cart_level_discount_applications || []).reduce((s, d) => s + d.total_allocated_amount, 0);
        this.dataset.totaal = items - korting;
        this.render();
      };
      document.addEventListener('cart:change', this.onCart);
    }
    disconnectedCallback() { document.removeEventListener('cart:change', this.onCart); }
    render() {
      const drempel = parseInt(this.dataset.drempel, 10), totaal = parseInt(this.dataset.totaal, 10);
      const tekst = this.querySelector('.herqs-gratis-balk__tekst'), vul = this.querySelector('.herqs-gratis-balk__vul');
      const bar = this.querySelector('.herqs-gratis-balk__balk');
      const pct = Math.max(0, Math.min(100, Math.round((totaal / drempel) * 100)));
      if (totaal >= drempel) { tekst.innerHTML = '<strong>Gratis verzending. Geregeld.</strong>'; this.classList.add('is-gehaald'); }
      else { tekst.textContent = `Nog ${geld(drempel - totaal)} tot gratis verzending`; this.classList.remove('is-gehaald'); }
      vul.style.width = pct + '%';
      bar.setAttribute('aria-valuenow', pct);
    }
  }
  if (!customElements.get('herqs-gratis-balk')) customElements.define('herqs-gratis-balk', HerqsGratisBalk);
})();
